import { ContactType, FindAllContactsFilters, FindContactsDatabaseResponse } from "../../../../lib/filters/dto";
import { DatabaseSection, TargetSection } from "../../../../lib/utils";
import { NotFound } from "../../../../ui/organisms/notFound";
import { ItemsPerPageValues } from "../../../../ui/organisms/pagination/dto";
import { Pagination } from "../../../../ui/organisms/pagination/index";
import { } from "../slice";
import { PeopleTable } from "./table";

interface Props {
  filters: FindAllContactsFilters
  section: DatabaseSection | TargetSection
  contacts: FindContactsDatabaseResponse<ContactType.PERSON>
  selectedIds: string[]
  setSelectedIds: (ids: string[]) => void
  onPageChange: (page: number) => void
  onItemsPerPageChange: (itemsPerPage: ItemsPerPageValues) => void
  onChangeFilters: (filters: Partial<FindAllContactsFilters>) => void
}

export function PeopleList(props: Props) {
  const { filters, onChangeFilters, onPageChange, onItemsPerPageChange, contacts, selectedIds, setSelectedIds } = props

  return (
    <div className="flex-grow w-full" style={{ height: 'calc(100% - 63.8px)' }}>
      {contacts.data.length === 0 ||
        contacts.data === null ? (
        <div style={{ height: 'calc(100% - 64px - 60px)' }}>
          <NotFound />
        </div>
      ) : (
        <PeopleTable selectedIds={selectedIds} setSelectedIds={setSelectedIds} section={props.section} contacts={contacts} filters={filters} updateFilters={onChangeFilters} />
      )}
      {
        !(contacts.data.length === 0 ||
          contacts.data === null) &&
        <Pagination
          itemsPerPage={filters.itemsPerPage}
          setItemsPerPage={onItemsPerPageChange}
          found={contacts.total || 0}
          key={"pagination-people-bottom"}
          pages={contacts.totalPage || 0}
          currentPage={contacts.page || 0}
          setPage={onPageChange}
        />
      }
    </div>
  );
}
